import { useNode, useEditor } from "@craftjs/core";
import React, { useContext, useEffect } from "react";
import { PostExcerptSettings } from "./settings";
import GrigoraCSSRenderer from "../css-render";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraDashboardContext } from "../../dashboard/context";

export const PostExcerpt = (props) => {
  const { domain, cmsPosts } = useContext(GrigoraDashboardContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode, setProp: setPropGlobal },
  } = useEditor();

  const {
    content = "This is the content of the post summary",
    excerptLength = 55,
    excerptSuffix = "...",
    linkPost,
    openInNewTab,
    link = "#",
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-post-excerpt": true,
      [`post-excerpt-${id}`]: id,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  function stripRenderedExcerpt() {
    if (!content) return "";
    const document = new window.DOMParser().parseFromString(
      content,
      "text/html",
    );
    return document.body.textContent || document.body.innerText || "";
  }

  const strippedRenderedExcerpt = stripRenderedExcerpt();

  function formattedExcerpt() {
    if (!strippedRenderedExcerpt) {
      return "";
    }

    // trim
    let trimmed = strippedRenderedExcerpt.trim();
    trimmed = trimmed.split(" ").splice(0, excerptLength).join(" ");

    // suffix
    if (trimmed) {
      if (trimmed.toLowerCase().endsWith(excerptSuffix.toLowerCase())) {
        trimmed = trimmed.slice(0, -excerptSuffix.length).concat(excerptSuffix);
      }
      if (!trimmed.toLowerCase().endsWith(excerptSuffix.toLowerCase())) {
        trimmed = trimmed.concat(excerptSuffix);
      }
    }

    return trimmed;
  }

  let excerptContent = <p>{formattedExcerpt()}</p>;
  if (linkPost) {
    excerptContent = (
      <p>
        {cmsPosts?.[0]?.summary ? (
          cmsPosts?.[0].summary
        ) : (
          <a
            href={`https://${domain}/${cmsPosts?.[0]?.slug}`}
            target={openInNewTab == true ? "_blank" : "_self"}
            onClick={(event) => event.preventDefault()}
            dangerouslySetInnerHTML={{
              __html: formattedExcerpt(),
            }}
            rel="noreferrer"
          />
        )}
      </p>
    );
  }

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={() => selected}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PostExcerpt(id, props)}`}</style>
      {excerptContent}
    </div>
  );
};

// To Avoid Mangling in Production
PostExcerpt.displayName = "PostExcerpt";

PostExcerpt.craft = {
  name: "Post Summary",
  props: {},
  related: {
    settings: PostExcerptSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "cms",
  },
  custom: {
    name: "Post Summary",
    slug: "grigora/post-excerpt",
  },
};
